module.exports = __webpack_public_path__ + "static/img/office365_logo.7dc014c.png";